module.exports = __webpack_public_path__ + "static/media/brand5.d33678ca.png";